export const getIdbyUrl = () => {
  const url = window.location.href;
  const urlSplit = url.split("/");
  const courseId = urlSplit[urlSplit.length - 1];
  console.log(courseId);
  return courseId;
};

export const ConvertTimeStamptoDate = (timestamp) => {
  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const getIdFromUrl = () => {
  try {
    const url = window.location.href;
    const id = url.split("/").pop();
    console.log(id);
    return id;
  } catch (error) {
    return null;
  }
};

export const interviewStatus = (data) => {
  try {
    if (
      data.jobPostId?.technicalInterview === null &&
      data.jobPostId?.mockTest === null &&
      data.hrInterview !== undefined
    ) {
      return true;
      console.log(" in hr");
    } else if (
      data.jobPostId?.hrInterview === null &&
      data.jobPostId?.mockTest === null &&
      data.technicalInterview !== undefined
    ) {
      return true;
      console.log(" in tech");
    } else if (
      data.jobPostId?.hrInterview === null &&
      data.jobPostId?.technicalInterview === null &&
      data.mockTest !== undefined
    ) {
      return true;
      console.log(" in mcq");
    } else if (
      data.jobPostId?.hrInterview === null &&
      data.jobPostId?.technicalInterview !== null &&
      data.jobPostId?.mockTest !== null &&
      data.mockTest !== undefined &&
      data.technicalInterview !== undefined
    ) {
      return true;
    } else if (
      data.jobPostId?.hrInterview !== null &&
      data.jobPostId?.technicalInterview === null &&
      data.jobPostId?.mockTest !== null &&
      data.mockTest !== undefined &&
      data.hrInterview !== undefined
    ) {
      return true;
    } else if (
      data.jobPostId?.hrInterview !== null &&
      data.jobPostId?.technicalInterview !== null &&
      data.jobPostId?.mockTest === null &&
      data.technicalInterview !== undefined &&
      data.hrInterview !== undefined
    ) {
      return true;
    } else if (
      data.jobPostId?.hrInterview !== null &&
      data.jobPostId?.technicalInterview !== null &&
      data.jobPostId?.mockTest !== null &&
      data.technicalInterview !== undefined &&
      data.hrInterview !== undefined &&
      data.mockTest !== undefined
    ) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
};

export const getParamFromUrl = (param) => {
  try {
    const url = window.location.href;
    const urlParams = new URL(url);
    const reqParam = urlParams.searchParams.get(param);
    return reqParam;
  } catch (error) {
    return null;
  }
};

export const removeUnusedFieldsInObject = (obj, arrayOfFields) => {
  const newObj = { ...obj };
  arrayOfFields.forEach((field) => {
    delete newObj[field];
  });
  return newObj;
};

export const isParamExist = () => {
  const url = window.location.href;
  const urlSplit = url.split("?");
  if (urlSplit.length > 1) {
    return true;
  } else {
    return false;
  }
};

export const getUserRoleFromLocalStorage = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      return user?.role?.role;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const getUserDetailsFromLocalStorage = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      return user;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const replaceWords = (sentence, replaceableWords) => {
  let result = sentence;

  replaceableWords.forEach((word) => {
    const regex = new RegExp(`^${word}:\s*`, "i"); // 'i' flag for case-insensitive matching
    result = result.replace(regex, "");
  });

  return result.trim();
};

export const removeCharInSetence = (sentence, char) => {
  try {
    const modifiedSentence = sentence.replace(char, "");

    return modifiedSentence;
  } catch (error) {
    return sentence;
  }
};

export const removeLucy = (sentence) => {
  try {
    const pattern = /^Lucy:\s*/;
    return sentence.replace(pattern, "");
  } catch (error) {
    return sentence;
  }
};

export const navigateToPageInNewTab = (url) => {
  const currentUrl = window.location.origin;
  window.open(`${currentUrl}/${url}`, "_blank");
};

export const scrollToBottomUsingId = (id) => {
  try {
    const element = document.getElementById(id);
    element.scrollTop = element.scrollHeight;
  } catch (error) {
    console.log(error);
  }
};
